import { GetApp } from "../../App"
import { Overlay } from "../../Components/Overlay"
import { Block, BlockContainer, BlockField, BlockRow } from "../../Components/Block"
import { LocalizedMessage } from "../../Components/LocalizedMessage"
import { LoginResetDialogViewProps } from "./Params"

export function LoginResetDialogView({ resetDialog, setResetDialog, resetApp }: LoginResetDialogViewProps) {
  const app = GetApp()!;
  const t = app.getT("LoginView");

  return (
    <Overlay style="alarm" title={t("reset_app_title")} hideClose={resetDialog > 1} closeCallback={() => setResetDialog(0)}>
      <BlockContainer className="Overlay-body LoginView-reset-dialog">
        <Block>
          <BlockRow>
            <LocalizedMessage message={(m) => resetDialog > 1 ? m.login.resetAppComplete : m.login.resetAppWarning} html={true} />
          </BlockRow>
          {resetDialog == 1 && (
            <BlockRow actions={true} className="LoginView-reset-dialog">
              <BlockField><button className="button" onClick={() => setResetDialog(0)}>{t("reset_app_cancel")}</button></BlockField>
              <BlockField><button className="button default" onClick={resetApp}>{t("reset_app_action")}</button></BlockField>
            </BlockRow>
          )}
        </Block>
      </BlockContainer>
    </Overlay>
  );
}
